
import { Calendar } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

interface MonthlyPromptCardProps {
  summary: string;
}

export default function MonthlyPromptCard({ summary }: MonthlyPromptCardProps) {
  if (!summary) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="h-5 w-5 text-green-500" />
          This Month's Focus
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground whitespace-pre-line">
          {summary}
        </p>
      </CardContent>
    </Card>
  );
}
